import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { Loader, PageHeader } from "@/components/common";

export default function Tools() {
  const [d, setD] = useState(null);
  const [cat, setCat] = useState("");
  useEffect(() => { api.get("/tools").then((r) => setD(r.data)); }, []);
  if (!d) return <Loader />;
  const list = d.tools.filter((x) => !cat || x.category === cat);
  return (
    <div data-testid="tools-page">
      <PageHeader eyebrow="Tools" title="Software we recommend" subtitle="Sidebizz doesn't rebuild these — we point you to the right tool at the right stage." />
      <div className="flex gap-2 overflow-x-auto no-scrollbar mb-5">
        {["", ...d.categories].map((c) => (
          <button key={c || "all"} onClick={() => setCat(c)} data-testid={`tools-cat-${c || "all"}`}
            className={`shrink-0 rounded-full px-4 h-9 text-xs font-bold border ${cat === c ? "bg-[#1E2B3C] text-white border-[#1E2B3C]" : "bg-white border-[#EADEC9] text-[#5C6B73]"}`}>{c || "All"}</button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 stagger">
        {list.map((x) => (
          <article key={x.id} className="sb-card p-5 flex flex-col" data-testid={`tool-card-${x.name.replace(/\s/g, "-").toLowerCase()}`}>
            <div className="flex items-center gap-3">
              <img src={x.logo_url} alt="" className="h-11 w-11 rounded-xl border border-[#EADEC9] p-1.5 bg-white" />
              <div><h3 className="font-display font-bold">{x.name}</h3><div className="text-[11px] text-[#8C9BA5]">{x.category} · {x.stage}</div></div>
            </div>
            <p className="text-sm text-[#5C6B73] mt-3">{x.description}</p>
            <dl className="text-xs mt-3 space-y-1.5 flex-1">
              <div><dt className="inline font-bold">Best for: </dt><dd className="inline text-[#5C6B73]">{x.best_for}</dd></div>
              <div><dt className="inline font-bold">Pricing: </dt><dd className="inline text-[#5C6B73]">{x.pricing}</dd></div>
              <div className="rounded-lg bg-[#E8F8F4] p-2 text-[#179B80] font-medium">Why Sidebizz recommends it: {x.why}</div>
            </dl>
            <a href={x.affiliate_url || x.website_url} target="_blank" rel="noreferrer" className="sb-btn-ghost mt-4 text-sm" data-testid={`tool-visit-${x.id}`}>Visit website <ExternalLink className="h-3.5 w-3.5" /></a>
          </article>
        ))}
      </div>
    </div>
  );
}
